// §9i — work log entries may only be added/edited if their date falls in the current or
// previous calendar week (Monday-start). This is upfront UX only — the backend
// (apps/api/src/modules/presales/work-log-edit-window.util.ts) independently re-validates on
// every write and is the real gate; the two copies can't share code across apps/api/apps/web,
// so keep them in sync manually if this logic ever changes.
import { getMondayOfWeek } from '../features/delivery/utils/resourceLevelling';

function toIsoDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function isEditableWorkLogDate(dateIso: string, today: Date = new Date()): boolean {
  const currentMonday = getMondayOfWeek(today);
  const previousMonday = new Date(currentMonday.getFullYear(), currentMonday.getMonth(), currentMonday.getDate() - 7);
  const currentSunday = new Date(currentMonday.getFullYear(), currentMonday.getMonth(), currentMonday.getDate() + 6);
  return dateIso >= toIsoDate(previousMonday) && dateIso <= toIsoDate(currentSunday);
}
